import {Tooltip} from 'react-tooltip'
import React, {useEffect, useState} from 'react'
import {ModelActionDemandeTransfert, ModeleDemandeTransfert} from '../../../components/Models'
import {getDemandeTransferts, validateOrRefuseDemandeTransfert} from '../../../components/requests'
import {Pagination} from '../../../components/Pagination'
import moment from 'moment/moment'
import {useAuth} from '../../modules/auth'
import Swal from 'sweetalert2'
import {useFormik} from 'formik'
import {toast} from 'react-toastify'
import {DateInput} from '../../../components/inputs/DateInput'
import {shouldDisplayFonctionnalite} from '../../../components/helpers'
import {VisualiserDemandeModal} from './VisualiserDemandeModal'

const DemandeTransfertListPage = () => {
  const [data, setData] = useState<Array<ModeleDemandeTransfert>>([])
  const [spinner, setSpinner] = useState(false)
  const userConnected = useAuth()
  const [nombreDePages, setNombreDePages] = useState<number>(0)
  const [totalPages, setTotalPages] = useState<number>(0)
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [searchPage, setSearchPage] = useState<string>(sessionStorage.getItem('searchPageT') ?? '')
  const [searchDateDebut, setSearchDateDebut] = useState<string>(
    sessionStorage.getItem('searchDateDebutT') ?? ''
  )
  const [searchDateFin, setSearchDateFin] = useState<string>(
    sessionStorage.getItem('searchDateFinT') ?? ''
  )
  // const [dateDebut, setDateDebut] = useState<string>('')
  // const [dateFin, setDateFin] = useState<string>('')
  const [status, setStatus] = useState<string>(sessionStorage.getItem('searchStatutT') ?? '')
  const [demandeTransfertToShow, setDemandeTransfertToShow] = useState<ModeleDemandeTransfert | null>(null)
  const statusValues: string[] = ['À valider', 'Refusé', 'Validé']
  const {currentUser} = useAuth()

  // Méthode centralisé pour obtenir la liste des demandes de transfert
  const getDemandeTransfertData = (enableSpinner: boolean = true) => {
    setSpinner(true)
    getDemandeTransferts(currentPage, searchPage, searchDateDebut, searchDateFin, status)
      .then((response) => {
        if (response?.status === 200 && response?.data !== null) {
          setData(response?.data?.data)
          setNombreDePages(response?.data?.pages)
          setTotalPages(response?.data?.total)
          setCurrentPage(response?.data?.page)
        } else {
          setData([])
        }
      })
      .catch((error) => console.log(error))
      .finally(() => {
        setSpinner(false)
      })
  }
  //

  // Appelation de la méthode de liste des demandes de transfert si
  // il y a un changement de page ou une recherche par filtre
  useEffect(() => {
    getDemandeTransfertData()
  }, [currentPage, searchPage, searchDateDebut, searchDateFin, status])

  // Méthode centralisé pour l'affichage d'un statut d'une demande
  const handleStatutValide = (validePar: any, valide: boolean) => {
    if (validePar === null) {
      if (!valide) {
        // Si il n'y a pas de validateur et que la propiété valide est false
        return <span className='badge badge-light-secondary text-gray-600'>À valider</span>
      }
    } else {
      if (!valide) {
        // Si il y a un validateur et que la propiété valide est false
        return <span className='badge badge-light-danger'>Refusé</span>
      } else if (valide) {
        // Si il y a un validateur et que la propiété valide est true
        return <span className='badge badge-light-primary'>Validé</span>
      }
    }
  }

  // Méthode centralisé sur la validation ou le refus d'une demande de transfert
  const handleValidateStatus = (
    demandeTransfertId: number | undefined,
    action: string,
    userConnectedId: number | undefined
  ) => {
    // Affichage du modal de validation
    Swal.fire({
      title: `${action === 'valider' ? 'Validation' : 'Refus'} de la demande de transfert`,
      text: 'Merci de confirmer votre action.',
      icon: action === 'valider' ? 'success' : 'warning',
      confirmButtonText: 'Confirmer',
      cancelButtonText: 'Annuler',
      showCancelButton: true,
      confirmButtonColor: '#1BC5BD',
      cancelButtonColor: '#F64E60',
      input: 'textarea',
      customClass: {
        input: 'form-control mt-5 mx-auto shadow-none',
      },
      inputAttributes: {
        placeholder: `Motif ${action === 'refuser' ? '*' : ''}`,
        ...(action === 'refuser') ? {required: 'true'} : {}
      },
      preConfirm: (value) => {
        // Afficher un message d'erreur si l'utilisateur insert une valeur invalide
        if (action === 'refuser') {
          if (value === null || value === undefined || value.trim() === '') {
            Swal.showValidationMessage('Le motif est obligatoire.')
          } else {
            return value
          }
        } else {
          return value
        }
      },
    }).then((alertResult) => {
      // Si le modal est confirmé
      if (alertResult.isConfirmed) {
        const id = toast.loading(`${action === 'valider' ? 'Validation' : 'Refus'} en cours...`)
        const params: ModelActionDemandeTransfert = {
          action: action,
          valideParId: userConnectedId,
          motif: alertResult.value,
        }
        validateOrRefuseDemandeTransfert(demandeTransfertId, params)
          .then((response) => {
            if (response?.status === 200) {
              const updatedData = data?.map((item) =>
                item?.id === response?.data?.id ? response.data : item
              )
              setData(updatedData)
              toast.update(id, {
                render: `${
                  action === 'valider' ? 'Validation' : 'Refus'
                } de la demande transfert avec succès`,
                type: 'success',
                isLoading: false,
                autoClose: 4000,
              })
            }
          })
          .catch((error) => {
            console.log('erreur')
            toast.update(id, {
              render: `Erreur durant ${
                action === 'valider' ? 'la validation' : 'le refus'
              } de la demande transfert`,
              type: 'error',
              isLoading: false,
              autoClose: 4000,
            })
          })
      }
    })
  }

  const formik = useFormik({
    initialValues: {
      allSearch: sessionStorage.getItem('searchPageT') ?? '',
      dateDebut: sessionStorage.getItem('searchDateDebutT') ?? '',
      dateFin: sessionStorage.getItem('searchDateFinT') ?? '',
      statut: sessionStorage.getItem('searchStatutT') ?? '',
    },
    onSubmit: (values) => {
      if (values?.dateDebut === '' && values?.dateFin !== '') {
        toast.warning('Veuillez préciser une date de début', {autoClose: 4000})
      } else {
        setSearchPage(values?.allSearch ?? '')
        setSearchDateDebut(values?.dateDebut ?? '')
        setSearchDateFin(values?.dateFin ?? '')
        setStatus(values?.statut ?? '')

        sessionStorage.setItem('searchPageT', values?.allSearch ?? '')
        sessionStorage.setItem('searchStatutT', values?.statut ?? '')
        sessionStorage.setItem('searchDateDebutT', values?.dateDebut ?? '')
        sessionStorage.setItem('searchDateFinT', values?.dateFin ?? '')
      }
    },
  })

  return (
    <>
      {/* begin::Row  */}
      <div className='row g-5 g-xl-8'>
        {/* begin::Col  */}
        <div className='col-lg-12 col-sm-12'>
          <div className={`card card-xxl-stretch mb-5 mb-xl-8`}>
            {/* debut champs recherche */}
            {shouldDisplayFonctionnalite(currentUser, 'VOIR DEMANDE TRANSFERT DEMONTAGE') && (
              <>
                <form
                  className='d-flex justify-content-between card-header border-0 mt-5 py-5'
                  onSubmit={formik.handleSubmit}
                >
                  <div className='col-lg-2 col-sm-12'>
                    <select
                      {...formik.getFieldProps('statut')}
                      name='statut'
                      className='form-select form-select-solid form-select-lg fw-bold'
                      onChange={(e) => {
                        formik.setFieldValue('statut', e.target.value)
                        setStatus(e.target.value)
                        sessionStorage.setItem('searchStatutT', e.target.value)
                      }}
                    >
                      <option value=''>Statut</option>
                      {statusValues.length &&
                        statusValues.map((item, index) => {
                          return (
                            <option key={index} value={item}>
                              {item}
                            </option>
                          )
                        })}
                    </select>
                  </div>
                  <div className='col-lg-3 col-sm-12'>
                    <DateInput
                      fieldName='dateDebut'
                      inputClassName='form-control'
                      value={formik.values.dateDebut}
                      setter={(val: string) => {
                        formik.setFieldValue('dateDebut', val)
                        sessionStorage.setItem('searchDateDebutT', val)
                      }}
                      formik={formik}
                      placeholder='Date début'
                      customHeight={true}
                    />
                  </div>
                  <div className='col-lg-3 col-sm-12'>
                    <DateInput
                      fieldName='dateFin'
                      inputClassName='form-control'
                      value={formik.values.dateFin}
                      setter={(val: string) => {
                        formik.setFieldValue('dateFin', val)
                        sessionStorage.setItem('searchDateFinT', val)
                      }}
                      formik={formik}
                      placeholder='Date fin'
                      customHeight={true}
                    />
                  </div>
                  <div className='col-lg-3 col-sm-12'>
                    <div className='form-group d-flex gap-3'>
                      <div className='input-group'>
                        <input
                          type='text'
                          className='form-control h-100'
                          {...formik.getFieldProps('allSearch')}
                          name='allSearch'
                          placeholder='Recherche par véhicule'
                        />
                      </div>
                      <button
                        type='submit'
                        className='btn btn-primary border-0 input-group-append h-100'
                      >
                        <i className='fas fa-search text-secondary fs-1'></i>
                      </button>
                    </div>
                  </div>
                </form>
                {/* fin champs recherche */}
                <div className='card-body py-3'>
                  {/* begin::Table container */}
                  <div className='table-responsive min-h-300px'>
                    {/* begin::Table */}
                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                      {/* begin::Table head */}
                      <thead>
                        <tr className='fw-bold text-muted'>
                          <th className='min-w-150px'>Vehicule</th>
                          <th className='min-w-150px'>Marque</th>
                          <th className='min-w-150px'>Modèle</th>
                          <th className='min-w-140px'>Demandeur</th>
                          <th className='min-w-140px'>Date</th>
                          <th className='min-w-140px'>Statut</th>
                          <th className='min-w-140px'>Commentaire</th>
                          <th className='min-w-40px text-end'>Action</th>
                        </tr>
                      </thead>
                      {/* end::Table head */}
                      {/* begin::Table body */}
                      <tbody>
                        {spinner ? (
                          <tr>
                            <td colSpan={8} className='p-4 text-center h-500px'>
                              <span className='spinner-border spinner-border-sm align-middle ms-2 w-30px h-30px'></span>
                            </td>
                          </tr>
                        ) : data.length === 0 ? (
                          <>
                            <tr>
                              <td colSpan={8} className='text-center'>
                                Aucun résultat trouvé
                              </td>
                            </tr>
                          </>
                        ) : (
                          data.map((demandeTransfert) => {
                            return (
                              <tr key={demandeTransfert?.id}>
                                <td>
                                  <div className='d-flex align-items-center'>
                                    <div className='d-flex justify-content-start flex-column'>
                                      <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0 ms-2'>
                                        <a
                                          href={`/demontage/liste?numeroVehicule=${demandeTransfert?.vehicule?.numero}`}
                                          target='_blank'
                                          rel='noopener noreferrer'
                                          data-tooltip-id='tooltip'
                                          data-tooltip-content='Voir la fiche du véhicule'
                                          data-tooltip-place='right'
                                        >
                                          {demandeTransfert?.vehicule?.numero}
                                        </a>
                                      </p>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                    {demandeTransfert?.vehicule?.vehicule?.modele?.marque?.nom}
                                  </p>
                                </td>
                                <td>
                                  <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                    {demandeTransfert?.vehicule?.vehicule?.modele?.nom}
                                  </p>
                                </td>
                                <td>
                                  <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                    {demandeTransfert?.demandePar?.nom}{' '}
                                    {demandeTransfert?.demandePar?.prenom}
                                  </p>
                                </td>
                                <td>
                                  <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                    {moment(demandeTransfert?.dateCreation).format(
                                      'DD/MM/YYYY à HH:mm'
                                    )}
                                  </p>
                                </td>
                                <td>
                                  <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                    {handleStatutValide(
                                      demandeTransfert?.validePar,
                                      demandeTransfert?.valide
                                    )}
                                  </p>
                                </td>
                                <td>
                                  <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                    {demandeTransfert?.commentaire}
                                  </p>
                                </td>
                                <td style={{verticalAlign: 'middle'}}>
                                  {shouldDisplayFonctionnalite(
                                    currentUser,
                                    'VALIDER-REFUSER DEMANDE TRANSFERT DEMONTAGE'
                                  ) && (
                                    <div className='d-flex justify-content-end align-items-center flex-shrink-0'>
                                      {demandeTransfert?.validePar === null &&
                                        demandeTransfert?.valide === false && (
                                          <button
                                            className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                                            data-bs-toggle="modal"
                                            data-bs-target="#visualiserDemandeModal"
                                            data-tooltip-id='tooltip'
                                            data-tooltip-content='Visualiser la demande'
                                            data-tooltip-place='left'
                                            onClick={() => {
                                              setDemandeTransfertToShow(demandeTransfert)
                                            }}
                                          >
                                            <img src='/media/svg/custom/File add.svg' width='25' alt='Fermer'/>
                                          </button>
                                        )}
                                    </div>
                                  )}
                                </td>
                              </tr>
                            )
                          })
                        )}
                      </tbody>
                      {/* end::Table body */}
                    </table>
                    {/* end::Table */}
                  </div>
                  {/* end::Table container */}

                  {/* begin::pagination*/}
                  {!spinner && (
                    <Pagination
                      totalPages={totalPages}
                      nombreDePages={nombreDePages}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      locationState={0}
                    />
                  )}
                  {/* end::pagination*/}
                  {/*Affichage du tooltip*/}
                  <Tooltip id='tooltip' />
                  <VisualiserDemandeModal
                    id={demandeTransfertToShow?.id}
                    userConnectedId={userConnected?.currentUser?.id}
                    handleValidateStatus={handleValidateStatus}
                    data={demandeTransfertToShow?.vehicule}
                  />
                </div>
              </>
            )}
          </div>
        </div>
        {/* end::Col  */}
      </div>
      {/* end::Row  */}
    </>
  )
}

export {DemandeTransfertListPage}
